// Author Liang Gang Qiang
// Date 2021-11-22 16:39:27

class ImfMstLocation {
constructor({
        id = null,
        code = '',
        parentId = '',
        parentName = '',
        name = '',
        machineCode = '',
        machineType = '',
        standWorkHour = '',
        manCount = '',
        seq = '',
        externalId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.parentId = parentId;
    this.parentName = parentName;
    this.name = name;
    this.machineCode = machineCode;
    this.machineType = machineType;
    this.standWorkHour = standWorkHour;
    this.manCount = manCount;
    this.seq = seq;
    this.externalId = externalId;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstLocation();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstLocation.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.admin.imfMstLocation.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.imfMstLocation.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentName',
        label: 'label.em.admin.imfMstLocation.grid.parentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentMachineType',
        label: 'label.em.admin.imfMstLocation.grid.parentMachineType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '集团' },
                            { value: '2', text: '公司' },
                            { value: '3', text: '车间/部门' },
                            { value: '4', text: '工段' },
                            { value: '5', text: '料仓' }
            ]
        }
        },
        {
        key: 'level',
        label: 'label.em.admin.imfMstLocation.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.imfMstLocation.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstLocation.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'machineType',
        label: 'label.em.admin.imfMstLocation.grid.machineType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '集团' },
                            { value: '2', text: '公司' },
                            { value: '3', text: '车间/部门' },
                            { value: '4', text: '工段' },
                            { value: '5', text: '料仓' }
            ]
        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.imfMstLocation.grid.seq',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'externalId',
        label: 'label.em.admin.imfMstLocation.grid.externalId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstLocation.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    parentIdFilter : '',
    parentNameFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    nameFilter : '',
    machineCodeFilter : '',
    machineTypeFilter : '',
    standWorkHourFilter : '',
    manCountFilter : '',
    externalIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.em.admin.imfMstLocation.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNameFilter',
        label: 'label.em.admin.imfMstLocation.filter.parentName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.imfMstLocation.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'machineTypeFilter',
        label: 'label.em.admin.imfMstLocation.filter.machineType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '集团' },
                { value: '2', text: '公司' },
                { value: '3', text: '车间/部门' },
                { value: '4', text: '工段' },
                { value: '5', text: '料仓' }
            ]
        }
        },
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.admin.imfMstLocation.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentName',
        label: 'label.em.admin.imfMstLocation.entity.parentName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstLocation.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'machineType',
        label: 'label.em.admin.imfMstLocation.entity.machineType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '集团' },
                { value: '2', text: '公司' },
                { value: '3', text: '车间/部门' },
                { value: '4', text: '工段' },
                { value: '5', text: '料仓' }
            ]
        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.imfMstLocation.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstLocation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstLocation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
